import {
  Component,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
  OnDestroy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { FormGeneralComponent } from '../form-general/form-general.component';
import { debounceTime, distinctUntilChanged, Subscription } from 'rxjs';
import {
  DataPagesGeneral,
  GeneralFormPage,
} from '../../../shared/models/pages-model/page-general.model';
import { Toll } from '../../../shared/models/components-general/menu-toll.model';
import {
  GeneralForm,
  InputsGeneralForm,
} from '../../../shared/models/pages-model/form-general.model';
import { environment } from '../../../../environments/environment';
import { DynamicPageService } from '../../../shared/services/dynamic-page.service';
import { GeneralService } from '../../../shared/services/general.service';
import { ToolPagesService } from '../../../shared/services/tool-pages.service';
import { InputFuntionService } from '../../../shared/services/input-funtion.service';
import { ButtonFunctionService } from '../../../shared/services/button-function.service';
import { LoadGeneralComponent } from '../../../shared/components-generals/load-general/load-general.component';
import { AnalysisComponent } from '../../static-pages/analysis/analysis.component';
import { BureauConsultationComponent } from '../../static-pages/bureau-consultation/bureau-consultation.component';
import { SummaryComponent } from '../../static-pages/summary/summary.component';
import { ConfirmClientComponent } from '../../static-pages/confirm-client/confirm-client.component';
import { AdministrativeComponent } from '../../static-pages/administrative/administrative.component';
import { PromiseLetterComponent } from '../../static-pages/promise-letter/promise-letter.component';
import { CaptureDataSuppliersComponent } from '../../static-pages/capture-data-suppliers/capture-data-suppliers.component';
import { ContractsComponent } from '../../static-pages/contracts-workflow/contracts.component';
import { GpsComponent } from '../../hybrid-page/gps/gps.component';
import { QuotationComponent } from '../../../quotation/quotation/quotation.component';
import { TranslateModule } from '@ngx-translate/core';
import { ModifyDates } from '../../../workflow/modify-dates/modify-dates';
import { NewQuotationComponent } from '../../../quotation/new-quotation/new-quotation.component';
import { CotStatus } from '../../../shared/models/workflow-model/workflow.model';
import { TaskList } from '../../hybrid-page/task-list/task-list';
import { FinancialStatementComponent } from '../../static-pages/financial-statement/financial-statement.component';
import { PaymentsDocs } from '../../static-pages/payments-docs/payments-docs';

@Component({
  selector: 'app-page-general',
  templateUrl: './page-general.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    ReactiveFormsModule,
    FormGeneralComponent,
    LoadGeneralComponent,
    AnalysisComponent,
    BureauConsultationComponent,
    SummaryComponent,
    ConfirmClientComponent,
    AdministrativeComponent,
    PromiseLetterComponent,
    CaptureDataSuppliersComponent,
    ContractsComponent,
    GpsComponent,
    QuotationComponent,
    TranslateModule,
    ModifyDates,
    TaskList,
    FinancialStatementComponent,
    PaymentsDocs,
  ],
})
export class PageGeneralComponent implements OnDestroy {
  public subscribeArray: Subscription[] = [];
  public subEmitNewForm: Subscription | null = null;
  public emitFuntionInput: Subscription | null = null;
  public arrayFormsId: number[] = [];
  @Input() cotStatus: CotStatus | null = null; // Solo se usa para la paguina de Tareas
  @Input() autoSave = false;
  @Input() starNgOnInit = false; // Falso para creaciones e nuevos Formularios True para Flujo de Trabajo
  @Input() idPage = 1;
  @Input() quotationId = 0;
  @Input() Data: DataPagesGeneral | null = null;
  @Input() tollArray: Toll[] = [];
  @Output() emitFunctionTool = new EventEmitter<{
    toll: Toll;
    formGroups: GeneralForm;
  }>();
  @Input() edit = false;
  public collectionFormsControls: { [key: string]: FormControl } = {};
  public collectionFormsControlsOrder: Record<string, FormControl[]> = {};
  private collectionInputs!: { [key: string]: any };
  public load = false;
  public URL_API = environment.apiURLNew;
  // Acceder a TODOS los formularios generados
  @ViewChildren(FormGeneralComponent) formGeneralComponents!: QueryList<FormGeneralComponent>;

  constructor(
    private dynamicPageService: DynamicPageService,
    private inputFuntionService: InputFuntionService,
    private fb: FormBuilder,
    private buttonFunctionService: ButtonFunctionService,
    private generalService: GeneralService,
    private toolPagesService: ToolPagesService,
  ) {
    // Alternativa para iniciar una Paguina Con emitNewForm o con ngOnInit ambas inbocan un startNewPage
    this.subEmitNewForm = this.dynamicPageService.emitNewForm.subscribe((event) => {
      if (event) {
        this.idPage = event.idPage;
        this.quotationId = event.quotationId;
        this.startNewPage();
      }
    });

    this.emitFuntionInput = this.inputFuntionService.emitFuntionInput.subscribe((event) => {
      if (event.action == 'copySolicitud') {
        setTimeout(() => {
          this.startNewPage();
        });
      }
      if (event.action == 'deleteMultiform') {
        this.removeMultiform(event.body.idForm, event.body.repeatIndex);
      }
    });
  }

  ngOnInit(): void {
    if (this.starNgOnInit) {
      this.startNewPage();
    }
  }

  ngOnDestroy(): void {
    this.subEmitNewForm ? this.subEmitNewForm.unsubscribe() : null;
    this.emitFuntionInput ? this.emitFuntionInput.unsubscribe() : null;
    this.unsubscribeAll();
  }

  // Esta Funcion trae un DataPege e inicia el flujo para renderisar una nueva Paguina
  public startNewPage(): void {
    this.load = true;
    this.dynamicPageService.transformForm(this.quotationId, this.idPage).then((savedData) => {
      if (savedData) {
        this.Data = savedData;
        this.startFormControlsAndForm();
      }
    });
  }

  public startFormControlsAndForm(): void {
    this.startFormControls().then(() => {
      setTimeout(() => {
        this.emitForm();
      }, 500);
    });
  }

  // Esta funcion crea  fornularios
  public emitForm(): void {
    this.unsubscribeAll();
    this.cretateCollectionControls();
    this.createCollectionInputs();
    this.startFuntion();
    this.load = false;
  }

  // funcion que orderna los inputs repetidos en fistintos formularios
  private groupControlsBySuffix(
    controls: Record<string, FormControl>,
  ): Record<string, FormControl[]> {
    const grouped: Record<string, any[]> = {};
    Object.entries(controls).forEach(([key, value]) => {
      const parts = key.split('-');
      const suffix = parts[parts.length - 2] + '-' + parts[parts.length - 1];

      if (!grouped[suffix]) {
        grouped[suffix] = [];
      }
      grouped[suffix].push(value);
    });

    return grouped;
  }

  public subscribeForm(): void {
    this.Data?.section.forEach((section) => {
      if (this.viewForm(section.idSection)) {
        section.forms.forEach((form) => {
          this.arrayFormsId.push(
            form.generateForm.formGroups ? form.generateForm.formGroups.idForm : 0,
          );
          form.generateForm.formGroups?.multifrom.forEach((multifrom) => {
            multifrom.fields.forEach((input) => {
              if (!input.formControl) return;

              const sub = input.formControl.valueChanges
                .pipe(
                  debounceTime(500), // evitar eventos muy rápidos
                  distinctUntilChanged(),
                )
                .subscribe((newValue) => {
                  const parts = input.idFullControl.split('-');
                  const key = parts.slice(-2).join('-');

                  input.value = newValue;

                  // Guardado automatico de archivos ligh (solo un archivo)
                  if (
                    input.typeInput === 'input-upload-ligh' &&
                    input.formControl!.dirty &&
                    !this.edit
                  ) {
                    this.toolPagesService.autoSaveFileLigh(input, this.quotationId);
                  }

                  //  AutoGuardado (autoSave)
                  if (
                    input.formControl?.valid &&
                    input.formControl.dirty &&
                    !this.edit &&
                    this.autoSave
                  ) {
                    if (
                      input.typeInput !== 'input-upload-ligh' &&
                      input.typeInput !== 'input-general-autocomplete'
                    ) {
                      this.toolPagesService.autoSave(input, this.quotationId);
                    }
                  }

                  // Agregar vandera de mayusculas
                  if (input.typeInput == 'input-general')
                    this.inputFuntionService.toUppercaseControl(input.formControl!);

                  // Actualiza los valores de los controles repetidos
                  if (
                    this.collectionFormsControlsOrder[key] &&
                    this.collectionFormsControlsOrder[key].length > 1
                  ) {
                    this.collectionFormsControlsOrder[key].forEach(
                      (contol: FormControl, conrolIndex) => {
                        contol.setValue(newValue, { emitEvent: false });
                      },
                    );
                  }
                  if (
                    input.typeInput == 'input-general' ||
                    input.typeInput == 'input-general-select' ||
                    input.typeInput == 'input-general-currency'
                  ) {
                    if (input.functionEvent) {
                      this.rumFuntions(input, multifrom.fields, false);
                    }
                  }
                  // Lógica para ordernar campos segun reglas de ordenamiento
                  this.toolPagesService.orfernByRuleFields(input, multifrom, form);
                });

              this.subscribeArray.push(sub);
            });
          });
        });
      }
    });
  }

  public unsubscribeAll(): void {
    this.subscribeArray.forEach((sub) => sub.unsubscribe());
    this.subscribeArray = []; // Limpia el arreglo después de desuscribirse
  }

  public async startFormControls(): Promise<boolean> {
    let terminado = true;
    this.Data?.section.forEach((section, sectionIndex) => {
      section.forms.forEach((data, dataIndex) => {
        if ((data as GeneralFormPage).form) {
          const generalFormPage = data as GeneralFormPage;
          const formGroupsArrayAux = generalFormPage.generateForm.formGroups;
          formGroupsArrayAux?.multifrom.forEach((fields) => {
            fields.fields.forEach((input, inputIndex) => {
              input.formControl = new FormControl(input.value);
              input.disabled ? input.formControl.disable() : null;
            });
          });
        }
      });
    });

    return terminado;
  }

  public emitButtonForm(event: { toll: Toll; formGroups: GeneralForm }) {
    if (event.toll.function === 'scrollRight') {
      const scrollContainer = document.getElementById(`${event.formGroups.idForm}`);
      if (!scrollContainer) {
        return;
      }
      const containerTop = scrollContainer.offsetTop;
      const containerHeight = scrollContainer.scrollHeight;
      const scrollTarget = containerTop + containerHeight + 49 - 32;
      window.scrollTo({
        top: scrollTarget,
        behavior: 'smooth',
      });
    }
    if (event.toll.function === 'scrollLeft') {
      const currentIndex = this.arrayFormsId.indexOf(event.formGroups.idForm);
      if (currentIndex <= 0) {
        return;
      }
      const prevFormId = this.arrayFormsId[currentIndex - 1];
      const prevFormElement = document.getElementById(`${prevFormId}`);
      if (!prevFormElement) {
        return;
      }
      const offsetTop = prevFormElement.offsetTop - 85 + 16;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth',
      });
    }
    this.emitFunctionTool.emit(event);
  }

  public emitButton(dataInput: string) {
    if (dataInput === 'saveAndValidFull') {
      Promise.all(
        this.formGeneralComponents.map((formComponent) => {
          if (this.viewForm(formComponent.idSection)) {
            return formComponent.markInvalidControlsAndCheck();
          } else {
            return true;
          }
        }),
      ).then((results) => {
        // Verificamos si todos los resultados son true
        const allValid = results.every((res) => res === true);
        if (allValid) {
          Promise.all(
            this.formGeneralComponents.map((formComponent) => {
              if (this.viewForm(formComponent.idSection)) {
                return formComponent.saveFrom(false, true);
              } else {
                return true;
              }
            }),
          ).then(() => {
            this.buttonFunctionService.emitFuntion.emit(true);
          });
        } else {
          this.generalService.viewSnacAlert('Formulario Invalido', 'error', 'Revisa los campos');
        }
      });
    }
    if (dataInput === 'saveFull') {
      this.saveFullPage().then((ress) => {
        this.buttonFunctionService.emitFuntion.emit(true);
      });
    }
    if (dataInput === 'addMultiform') {
      this.resetSuscrip();
    }
  }

  // Crea los controladores de cada formulario
  private cretateCollectionControls() {
    const formGroupArray: FormArray<FormGroup> = this.fb.array<FormGroup>([]);
    this.collectionFormsControls = {};
    this.formGeneralComponents.forEach((formComponent) => {
      const formGroupAux = formComponent.createFormPage();
      formGroupArray.push(formGroupAux.form);
      const controls = Object.keys(formGroupAux.collectionFormsControls);
      controls.forEach((contol) => {
        this.collectionFormsControls[contol] = formGroupAux.collectionFormsControls[contol];
      });
    });
    this.collectionFormsControlsOrder = this.groupControlsBySuffix(this.collectionFormsControls);
  }

  public emitRulesQuotation(emitRule: { quotationId: number }): void {
    if (this.Data?.idPage == 4 || this.Data?.idPage == 15) {
      window.scrollTo({ top: 0 });
      this.quotationId = emitRule.quotationId;
      this.startNewPage();
    }
  }

  public viewForm(id: number): boolean {
    if (!this.Data!.rules.rulesSection) return true;
    const ruleGroup = this.Data!.rules.rulesSection[id];
    if (!ruleGroup) return true;

    return Object.values(ruleGroup.rulesInput).some(
      (rule) =>
        this.collectionFormsControlsOrder[rule.parentFieldId]?.[0].value ===
          rule.parentFieldValue && this.Data!.section.some((section) => section.idSection === id),
    );
  }

  // Crea una colección de inputs para acceder a ellos de forma mas sencilla
  public createCollectionInputs() {
    this.collectionInputs = {};
    this.Data?.section.forEach((section) => {
      section.forms.forEach((fomrs) => {
        fomrs.generateForm.formGroups?.multifrom.forEach((multifrom) => {
          multifrom.fields.forEach((input) => {
            this.collectionInputs[input.idFullControl] = input;
          });
        });
      });
    });
  }

  // Ejecuta las funciones al iniciar el formulario y al terminar se susvcribe a los cambios de los inputs
  public startFuntion() {
    this.Data?.section.forEach((section, sectionIndex) => {
      section.forms.forEach((fomrs, indexfomr) => {
        fomrs.generateForm.formGroups?.multifrom.forEach((multifrom, indexMultifrom) => {
          multifrom.fields.forEach((input, indexInput) => {
            if (input.typeInput === 'input-general-select' && (input.functionEvent || input)) {
              const waitForArrayData = () => {
                if (input.arrayData && input.arrayData.length > 0) {
                  this.rumFuntions(input, multifrom.fields, true);
                } else {
                  setTimeout(waitForArrayData, 200);
                }
              };

              waitForArrayData();
            } else {
              this.rumFuntions(input, multifrom.fields, true);
            }
            this.toolPagesService.catalogs(input);
            this.toolPagesService.orfernByRuleFields(input, multifrom, fomrs);
            if (
              this.Data?.section.length === sectionIndex + 1 &&
              fomrs.generateForm.formGroups?.multifrom.length === indexMultifrom + 1 &&
              multifrom.fields.length === indexInput + 1
            ) {
              setTimeout(() => {
                this.unsubscribeAll();
                this.subscribeForm();
              }, 500);
            }
          });
        });
      });
    });
  }

  private rumFuntions(input: InputsGeneralForm, fields: InputsGeneralForm[], starFuntion: boolean) {
    if (input.functionEvent) {
      // Caso para recargar suscripciones Formularios
      // resetSus
      if (
        input.functionEvent.event &&
        input.functionEvent.event.function == 'resetSuscrip' &&
        input.formControl?.valid &&
        input.formControl.value !== ''
      ) {
        this.resetSuscrip();
      }

      if (
        input.formControl?.valid &&
        input.formControl.value != '' &&
        input.functionEvent.catalog &&
        input.functionEvent.catalog.url != '' &&
        input.functionEvent.catalog.input != ''
      ) {
        // Funcion Catalogo (Inyecta catalogo a otro Select)
        this.toolPagesService.catalogFunction(input, fields);
      }
      if (
        input.formControl?.valid &&
        input.functionEvent.event &&
        input.functionEvent.event.function != '' &&
        input.typeInput != 'button-general' &&
        starFuntion &&
        input.functionEvent.event.starFuntion
      ) {
        // Ejecuta funciones al iniciar el formulario
        this.inputFuntionService.colectionFuntions(input, fields, this.quotationId, starFuntion);
      }

      if (
        input.formControl?.valid &&
        input.functionEvent.event &&
        input.functionEvent.event.function != '' &&
        input.typeInput != 'button-general' &&
        !starFuntion &&
        input.functionEvent.event.eventFuntion
      ) {
        // Ejecuta funciones al cambiar el valor del input
        this.inputFuntionService.colectionFuntions(input, fields, this.quotationId, starFuntion);
      }
    }
  }

  private saveFullPage(hideMessage?: boolean, hideLoad?: boolean) {
    return Promise.all(
      this.formGeneralComponents.map((formComponent) =>
        formComponent.saveFrom(hideMessage, hideLoad),
      ),
    );
  }

  private loadData(): void {
    this.dynamicPageService.transformForm(this.quotationId, this.idPage).then((savedData) => {
      if (savedData) {
        savedData.section.forEach((section) => {
          section.forms.forEach((fomrs) => {
            fomrs.generateForm.formGroups?.multifrom.forEach((multifrom) => {
              multifrom.fields.forEach((input) => {
                this.collectionFormsControls[input.idFullControl].setValue(input.value, {
                  emitEvent: false,
                });
              });
            });
          });
        });
      }
    });
  }

  public expandAll(): void {
    this.formGeneralComponents.forEach((formComponent) => (formComponent.isExpasion = true));
  }

  public collapseAll(): void {
    this.formGeneralComponents.forEach((formComponent) => (formComponent.isExpasion = false));
  }

  public resetSuscrip() {
    this.cretateCollectionControls();
    this.unsubscribeAll();
    this.subscribeForm();
  }

  // Quita en vivo un multiformulario (aval/apoderado) eliminado, sin recargar la página ni mover el scroll
  private removeMultiform(idForm: number, repeatIndex: number): void {
    this.Data?.section.forEach((section) => {
      section.forms.forEach((form) => {
        const formGroups = (form as GeneralFormPage).generateForm.formGroups;
        if (formGroups?.idForm === idForm) {
          const index = formGroups.multifrom.findIndex((m) => m.repeatIndex === repeatIndex);
          if (index !== -1) {
            formGroups.multifrom.splice(index, 1);
          }
        }
      });
    });
  }
}
